import API from 'utils/api';
import { URIconfiguracionesDeSegmentosPresupuestales } from 'utils/URIsSac';

/**
 * Normaliza el nombre de un segmento presupuestal para compararlo sin importar
 * acentos ni mayúsculas ("CLASIFICACIÓN FUNCIONAL" -> "clasificacion funcional").
 * @param {string} nombre
 * @returns {string}
 */
export const normalizarNombreSegmento = (nombre = '') => nombre
  .normalize('NFD')
  .replace(/[̀-ͯ]/g, '')
  .toLowerCase()
  .trim();

/**
 * Campo de la clave presupuestal de egresos -> nombres (normalizados) del segmento
 * presupuestal que lo habilita. Incluye los nombres viejos de las configuraciones
 * creadas antes del catálogo base del fixture 164.
 */
export const SEGMENTOS_POR_CAMPO = {
  identificador_geografico: ['identificador geografico', 'entidad'],
  directorio_de_area: ['area', 'unidad responsable'],
  destino_presupuestal: ['destino presupuestal'],
  programa: ['programa'],
  proyecto: ['proyecto'],
  funcion_presupuestal: ['funcion presupuestal'],
  clasificacion_administrativa: ['clasificacion administrativa'],
  clasificacion_funcional: ['clasificacion funcional'],
  clasificacion_programatica: ['clasificacion programatica'],
  clasificador_de_objeto_de_gasto: [
    'clasificador por objeto del gasto',
    'clasificador objeto gasto',
  ],
  tipo_de_gasto: ['tipo de gasto', 'tipo gasto'],
  fuente_financiamiento: ['fuente de financiamiento', 'fuente financiamiento'],
  tipo_de_nomina_empleado: ['tipo de nomina empleado'],
  cuenta_contable_conac: ['plan de cuentas'],
  cuenta_contable: ['cuenta contable', 'cuenta contables'],
};

/**
 * Indica si el campo debe mostrarse según los segmentos configurados.
 * - undefined: los segmentos aún se están cargando -> los campos que dependen de un
 *   segmento se ocultan para no mostrarlos un instante y luego quitarlos.
 * - null: no hay configuración de segmentos -> se muestra todo.
 * Los campos que no dependen de un segmento siempre se muestran.
 * @param {object[]|null|undefined} segmentos Segmentos de la configuración
 * @param {string} campo Nombre del campo de la clave presupuestal
 * @returns {boolean}
 */
export const segmentoAplica = (segmentos, campo) => {
  const nombres = SEGMENTOS_POR_CAMPO[campo];
  if (!nombres) return true;
  if (segmentos === undefined) return false;
  if (!segmentos) return true;
  return segmentos.some(
    (seg) => seg.el_segmento_aplica && nombres.includes(normalizarNombreSegmento(seg.nombre)),
  );
};

/**
 * GET segmentos de una configuración de segmentos presupuestales.
 * @param {number} configuracionId
 * @returns {Promise<object[]|null>} null si no hay configuración o falla la consulta
 */
export const getSegmentosDeConfiguracion = async (configuracionId) => {
  if (!configuracionId) return null;
  try {
    const { data } = await API.get(
      `${URIconfiguracionesDeSegmentosPresupuestales}${configuracionId}/segmentos/`,
    );
    return Array.isArray(data) ? data : null;
  } catch (err) {
    return null;
  }
};
